import RestClient from './RestClient';
import IntegrationEvent from '../../models/IntegrationEvent';

class IntegrationEvents extends RestClient {
    constructor() {
        super({
            model: IntegrationEvent,
            entryPoint: 'integration_event',
            resource: 'integration_event',
            resources: 'integration_events',
        });
    }

    replayWebhook(deliveryId) {
        return this.POST('/integration_event/replay_webhook', { delivery_id: deliveryId })
            .then((response) => response.json())
            .then((json) => {
                if (json.integration_delivery) {
                    return json;
                }
                throw new Error(json.flash?.error || 'Replay failed');
            });
    }

    replayCallback(deliveryId) {
        return this.POST('/integration_event/replay_callback', { delivery_id: deliveryId })
            .then((response) => response.json())
            .then((json) => {
                if (json.integration_delivery) {
                    return json;
                }
                throw new Error(json.flash?.error || 'Replay failed');
            });
    }
}

export default new IntegrationEvents();
